import { z } from "zod";

export const certificateIssueSchema = z.object({
  issue_date: z.string(),
});

export type CertificateIssue = z.infer<typeof certificateIssueSchema>;
